/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloads_Compatibility_MacosInputs */

const en_downloads_compatibility_macos = /** @type {(inputs: Downloads_Compatibility_MacosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requires macOS 12 Monterey or later. Universal for Intel and Apple silicon.`)
};

const es_downloads_compatibility_macos = /** @type {(inputs: Downloads_Compatibility_MacosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requiere macOS 12 Monterey o posterior. Universal para Intel y Apple silicon.`)
};

/**
* | output |
* | --- |
* | "Requires macOS 12 Monterey or later. Universal for Intel and Apple silicon." |
*
* @param {Downloads_Compatibility_MacosInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const downloads_compatibility_macos = /** @type {((inputs?: Downloads_Compatibility_MacosInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloads_Compatibility_MacosInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_downloads_compatibility_macos(inputs)
	return en_downloads_compatibility_macos(inputs)
});